import { apiRequest } from './client';

export async function subscribeNewsletter(email: string, country: string) {
  return apiRequest<{ message: string }>('/newsletter/subscribe', {
    method: 'POST',
    body: { email, country },
  });
}

export async function unsubscribeNewsletter(email: string) {
  return apiRequest<{ message: string }>('/newsletter/unsubscribe', {
    method: 'POST',
    body: { email },
  });
}

// 確認 (confirm) 系のヘルパーはここには置かない。
//
// メール内リンクのプリフェッチ (Outlook SafeLinks 等) でトークンが
// 消費されるのを避けるため、確認は GET ではなくユーザーのボタン操作に
// よる POST で行う。呼び出しは Confirm*Page.tsx が直接 fetch している。
